import styled from '@emotion/styled';
import * as React from 'react';

export interface MetaPillWidgetProps {
  children?: React.ReactNode;
  label: React.ReactNode;
  value?: React.ReactNode;
}

export const MetaPillWidget: React.FC<MetaPillWidgetProps> = ({ children, label, value }) => {
  const content = value ?? children;

  return (
    <S.Root>
      <S.Label $hasValue={Boolean(content)}>{label}</S.Label>
      {content ? <S.Value>{content}</S.Value> : null}
    </S.Root>
  );
};

namespace S {
  export const Root = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    max-width: 100%;
    min-width: 0;
  `;

  export const Label = styled.span<{ $hasValue: boolean }>`
    color: ${(p) => p.theme.text.paragraph};
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    line-height: 1.2;
    text-transform: uppercase;
    white-space: nowrap;
    opacity: 0.76;

    &::after {
      content: ${(p) => (p.$hasValue ? "':'" : "''")};
    }
  `;

  export const Value = styled.span`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    min-width: 0;
    color: ${(p) => p.theme.text.heading};
    font-size: 13px;
    line-height: 1.5;
  `;
}
